import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { createApp } from 'vue';
import { v4 as uuidv4 } from 'uuid';

import FormLogin from 'components/Login/FormLogin.vue';
import ProductCard from 'components/Products/ProductCard.vue';
import ProductAddCart from 'components/Products/ProductAddCart.vue';
import ProductFilter from 'components/Products/ProductFilter.vue';
import FilterCategory from 'components/Products/FilterCategory.vue';
import FilterFieldSelector from 'components/Filters/FilterFieldSelector.vue';
import FilterFieldSelectorOptions from 'components/Filters/FilterFieldSelectorOptions.vue';
import FilterFieldMultiselector from 'components/Filters/FilterFieldMultiSelector.vue';
import FilterFieldMultiselectorOptions from 'components/Filters/FilterFieldMultiselectorOptions.vue';
import FilterFieldMultiOptions from 'components/Filters/FilterFieldMultiOptions.vue';
import FilterFieldMultiOptionsOpt from 'components/Filters/FilterFieldMultiOptionsOpt.vue';
import FilterFieldCheckbox from 'components/Filters/FilterFieldCheckbox.vue';
import FilterFieldCheckboxOptions from 'components/Filters/FilterFieldCheckboxOptions.vue';
import FilterFieldRange from 'components/Filters/FilterFieldRange.vue';
import FilterFieldRangeOptions from 'components/Filters/FilterFieldRangeOptions';
import FormRequest from 'components/Login/FormRequest.vue';
import FormForgotAccount from 'components/Login/FormForgotAccount.vue';
import Navbar from 'components/Navbar/Navbar.vue';
import SearchInput from 'components/Navbar/SearchInput.vue';
import AlertSuccess from 'components/Alerts/AlertSuccess.vue';
import CookieAlert from 'components/Alerts/CookieAlert.vue';
import TermsAlert from 'components/Alerts/TermsAlert.vue';
import Cart from 'components/Cart/Cart.vue';
import ContactForm from 'components/Customer/ContactForm.vue';
import FormCustomer from 'components/Customer/FormCustomer.vue';
import FormCustomerPassword from 'components/Customer/FormCustomerPassword.vue';
import CommercialBanner from 'components/Products/CommercialBanner.vue';

import FormPurchase from 'components/Cart/FormPurchase.vue';

import Particles from "vue3-particles";




require('prototype--sodigital');

window.addEventListener('load', function () {
    document.sodigital(0.4);

    const app = createApp({
        el: '#app',
        data() {
            return {
                cartAdded: false,
                cartPayload: null,
                showWait: false,
            };
        },
        methods: {
            wait( status ){
                this.showWait = status;
            },
            addToCart(payload) {
                this.cartAdded = true;

                this.cartPayload = payload

                this.addCartAJAX( payload.productId, payload.productQuantity, payload.variantId)
                    .then(cart => {
                        this.wait(false);
                    })
                    .catch(error => {
                        console.error('Error adding cart', error)
                        this.wait(false);
                    })

            },

            addCartAJAX(productId,quantity, variantId) {

                const idx = uuidv4();

                return new Promise((resolve, reject) => {
                    fetch(`/cart/add/${productId}/${variantId}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        },
                        body: JSON.stringify({
                            idx: idx,
                            quantity: quantity,
                        })
                    })
                    .then(response => {


                        if(!response.ok) {
                            throw new Error(`HTTP error ${response.status}`);
                        }
                        console.log(response)
                        return response.json();
                    })
                    .then(resolve)
                    .catch(reject);
                })

            },

            updateCartCount(newQty) {
                this.cartPayload = { totalQty: newQty }
            },

            resetCartAdded(){
                this.cartAdded = false;
            },

        },
    });

    app
    .component('product-card', ProductCard)
    .component('product-filter', ProductFilter)
    .component('form-login', FormLogin)
    .component('form-request', FormRequest)
    .component('form-forgot-account', FormForgotAccount)
    .component('navbar-bar', Navbar)
    .component('search-input', SearchInput)
    .component('alert-success', AlertSuccess)
    .component('product-add-cart', ProductAddCart)
    .component('cookie-alert', CookieAlert)
    .component('filter-category', FilterCategory)
    .component('filter-field-selector', FilterFieldSelector)
    .component('filter-field-selector-options', FilterFieldSelectorOptions)
    .component('filter-field-multiselector', FilterFieldMultiselector)
    .component('filter-field-multiselector-options', FilterFieldMultiselectorOptions)
    .component('filter-field-multioptions', FilterFieldMultiOptions)
    .component('filter-field-multioptions-opt', FilterFieldMultiOptionsOpt)
    .component('filter-field-checkbox', FilterFieldCheckbox)
    .component('filter-field-checkbox-options', FilterFieldCheckboxOptions)
    .component('filter-field-range', FilterFieldRange)
    .component('filter-field-range-options', FilterFieldRangeOptions)
    .component('terms-alert', TermsAlert)
    .component('cart', Cart)
    .component('contact-form', ContactForm)
    .component('form-customer', FormCustomer)
    .component('form-customer-password', FormCustomerPassword)
    .component('commercial-banner', CommercialBanner)
    .component('form-purchase', FormPurchase)




    app.use(VueSweetalert2);
    app.use(Particles);


    const vm = app.mount('#app');


    const language = document.getElementsByTagName('html')[0].lang;

    var home_servicesTitle = document.getElementsByClassName('service__subtitle');

    if (language === "pt") {
        for(var i=0; i< home_servicesTitle.length; i++) {
            home_servicesTitle[i].classList.add('pt');
        }
    }
})

